import React from "react";

const MobileFilterDrawer = ({
  isOpen,
  onClose,
  title,
  searchTerm,
  onSearchChange,
  filterItems,
  selectedItems,
  onItemToggle,
  searchPlaceholder,
}) => {
  // Prevent clicks inside the drawer from closing it
  const handleDrawerClick = (e) => {
    e.stopPropagation();
  };

  // Handle item selection without closing the drawer
  const handleItemSelect = (item, e) => {
    e.preventDefault();
    e.stopPropagation();
    // console.log(`Toggling item: ${item}, Currently selected: ${selectedItems.includes(item)}`);
    onItemToggle(item);
  };

  // Clear all selected items
  const handleClearAll = (e) => {
    e.stopPropagation();
    e.preventDefault();
    // Clear all selected items one by one
    [...selectedItems].forEach(item => onItemToggle(item));
  };

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        >
          {/* Drawer: mobile bottom, desktop right */}
          <div
            className={`
              fixed bg-white z-50 transform transition-transform duration-300
              max-h-[80vh] overflow-y-auto
              inset-x-0 bottom-0 rounded-t-xl p-4 shadow-lg
              md:inset-y-0 md:inset-x-auto md:right-0 md:top-0 md:bottom-0 md:w-[400px] md:rounded-t-none md:rounded-l-xl
            `}
            onClick={handleDrawerClick}
            style={{
              boxShadow: "0 -4px 6px -1px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
                <p className="text-xs text-gray-500 mt-1">
                  <strong>Select multiple options</strong> (currently selected: {selectedItems.length})
                </p>
              </div>
              <button
                className="p-2 rounded-full hover:bg-gray-100"
                onClick={onClose}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>

            {/* Search */}
            <div className="mb-4">
              <input
                type="text"
                value={searchTerm}
                onChange={onSearchChange}
                placeholder={searchPlaceholder}
                className="w-full px-4 py-2 border-2 border-blue-600 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                onClick={(e) => e.stopPropagation()}
              />
            </div>

            {/* Filter List with Checkbox Style */}
            <div className="grid grid-cols-2 gap-2">
              {filterItems.length > 0 ? (
                filterItems.map((item, index) => (
                  <div
                    key={index}
                    className={`p-3 border rounded-lg cursor-pointer text-sm ${
                      selectedItems.includes(item)
                        ? "bg-blue-100 border-blue-300 text-blue-800"
                        : "bg-white border-gray-200 hover:bg-gray-50"
                    }`}
                    onClick={(e) => handleItemSelect(item, e)}
                  >
                    <div className="flex items-center">
                      <div className="w-4 h-4 border rounded mr-2 flex items-center justify-center">
                        {selectedItems.includes(item) && (
                          <svg
                            className="w-3 h-3 text-blue-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        )}
                      </div>
                      <span className="truncate">{item}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-2 py-4 text-center text-gray-500">
                  No options match your search
                </div>
              )}
            </div>

            {/* Selected Count and Action Buttons */}
            <div className="mt-4 pt-3 border-t border-gray-200">
              <div className="flex justify-between items-center mb-3">
                <span className="text-sm text-gray-600">
                  <span className="font-medium">{selectedItems.length}</span>{" "}
                  selected
                </span>
                <button
                  onClick={handleClearAll}
                  className="text-sm text-blue-600 hover:text-blue-800"
                >
                  Clear All
                </button>
              </div>

              <button
                onClick={onClose}
                className="w-full py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                Apply Filters ({selectedItems.length})
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileFilterDrawer;
